import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createProduct } from "../api/createProduct";
import type { ProductData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useCreateProduct = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: ProductData) => createProduct(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: withPrefix(['products']) });
        },
    });
};
